import React, { useState, createContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

import Layer1 from "../../../Assets/Images/AboutUs/Layer_1.png";
import Header from "Components/Header/Header";
import MobileHeader from "Components/Header/MobileHeader";
import PageHeading from "Components/PageHeading/PageHeading";
import Footer from "Components/Footer/Footer";
import AboutIntro from "./AboutIntro";
import CustomButton from "Components/Commons/CustomButton/CustomButton";
import SubscriptionPlans from "./SubscriptionPlans";
import SubscriptionSubjects from "./SubscriptionSubjects";
import SubscriptionSummary from "./SubscriptionSummary";

import { SubscriptionDetailsContainer, } from "./SubscriptionDetails.style";
import { Api, } from "Helpers";
import { planDetails, subjectsArray } from "./subscriptionUtil";

export const UserSubscriptionValueContext = createContext();

function SubscriptionDetails() {
	const location = useLocation();
	const getDetails = new URLSearchParams(window?.location?.search);
	const emailToken = getDetails.get("token");
	const checkEmailVerification = getDetails.get("email");
	const schoolId = getDetails.get("id") || location?.state?.schoolId;
	const checkAlreadyRegisterSchool = getDetails.get("isAlreadyRegistered");
	const schoolSubscriptionDetails = location?.state?.schoolSubscriptionDetails;
	const planSelectedFromAnotherPage = location?.state?.plan

	const [currentStep, setCurrentStep] = useState(1);

	const [subscriptionPlanDetails, setSubscriptionPlanDetails] = useState({
		...planDetails[0],
	});

	const [emailVerification, setEmailVerification] = useState(JSON.parse(checkEmailVerification));
	const [isAlreadyRegisteredSchool, setIsAlreadyRegisteredSchool] = useState(false);

	useEffect(() => {
		if (emailVerification) {
			registerAccount();
		}
		if (checkAlreadyRegisterSchool && JSON.parse(checkAlreadyRegisterSchool)) {
			getSubscriptionDataOfSchool();
		}
		if (schoolSubscriptionDetails) {
			subscriptionDataOfSchool(schoolSubscriptionDetails);
		}
		//eslint-disable-next-line
	}, []);

	useEffect(() => {
		if (planSelectedFromAnotherPage) {
			const findDataList = planDetails.find((item) => item.planName.toLowerCase() === planSelectedFromAnotherPage.toLowerCase());
			if (findDataList && Object.keys(findDataList).length) {
				setSubscriptionPlanDetails({ ...findDataList });
			}
		}
	}, [planSelectedFromAnotherPage])

	const registerAccount = async () => {
		let data = new FormData();
		data.append("emailVerificationToken", emailToken);
		const response = await new Api().post("user/verificationToken ", { data });

		if (response.status === 200 || response.status === 201) {
			setEmailVerification(false);

			if (response.data) {
				getSubscriptionDataOfSchool();
			}
		}
	};

	const getSubscriptionDataOfSchool = async () => {
		const subscriptionResponse = await new Api().get("school/subscription-details", { params: { schoolId: schoolId } });

		if (subscriptionResponse.status === 200 || subscriptionResponse.status === 201) {
			const data = subscriptionResponse.data;
			subscriptionDataOfSchool(data);
		}
	};

	const subscriptionDataOfSchool = (data) => {
		const dataList = Object.keys(data);

		const findDataList = planDetails.find((item) => item.planName === data?.planType);

		let subDataList = {};

		const subtypeValue = data?.subType && data.subType.replace(" ", " - ");

		if (Object.keys(findDataList) && Object.keys(findDataList).length) {
			subDataList = findDataList?.subType.find((item) => item?.subTypeName === subtypeValue);
		}

		const subjectNames = [...data?.subjectName];

		const SubjectNamesNew = subjectsArray.filter((data) => subjectNames?.includes(data?.subject))?.map((item) => item?.subjectId);

		if (dataList && dataList.length) {
			setSubscriptionPlanDetails({
				planTitle: data?.planType ? data.planType + " Plan" : "Basic Plan",
				planName: data?.planType ? data.planType : "Basic",
				subType: subDataList?.type || "",
				allowedSubjects: data?.noOfSubjects,
				price: "$ " + data?.cost,
				selectedSubjects: SubjectNamesNew,
				subTypeName: subtypeValue,
			});
			setCurrentStep(3);
			setIsAlreadyRegisteredSchool(true);
		}
	};

	const handleSelectedPlan = (planDetails) => {
		setSubscriptionPlanDetails({ planTitle: planDetails.planTitle, planName: planDetails.planName, ...planDetails });
	};

	const handleSelectSubjects = (planDetails, subTypeDetails) => {
		setSubscriptionPlanDetails({
			planTitle: planDetails.planTitle,
			planName: planDetails.planName,
			subType: subTypeDetails?.type || "",
			allowedSubjects: subTypeDetails?.allowedSubjects,
			price: subTypeDetails?.price,
			subTypeName: subTypeDetails.subTypeName,
		});
		setCurrentStep(2); // Navigate to subjects selection
	};
	const responseSteps = [
		{
			id: 1,
			stepComponent: (props) => (
				<UserSubscriptionValueContext.Provider value={{ subscriptionPlanDetails, setSubscriptionPlanDetails, handleSelectedPlan, handleSelectSubjects, currentStep, setCurrentStep }}>
					<SubscriptionPlans {...props} />
				</UserSubscriptionValueContext.Provider>
			),
		},
		{
			id: 2,
			stepComponent: (props) => (
				<UserSubscriptionValueContext.Provider value={{ setCurrentStep, subscriptionPlanDetails, setSubscriptionPlanDetails }}>
					<SubscriptionSubjects {...props} />
				</UserSubscriptionValueContext.Provider>
			),
		},
		{
			id: 3,
			stepComponent: (props) => (
				<UserSubscriptionValueContext.Provider value={{ setCurrentStep, subscriptionPlanDetails, schoolId, isAlreadyRegisteredSchool }}>
					<SubscriptionSummary {...props} />
				</UserSubscriptionValueContext.Provider>
			),
		},
	];

	return (
		<SubscriptionDetailsContainer>
			<Header />
			<MobileHeader />
			<PageHeading
				title={
					<>
						Subscription <span className="redfont">Plans</span>
					</>
				}
				breadcrumbs={[{ label: "Home", path: "/" }, { label: "Subscription Plans" }]}
			/>
			<AboutIntro />

			{/* Step-based rendering system */}
			{currentStep === 1 && (
				<div className="mygrid-container">
					<div className="plan_name_lists">
						<div className="mygrid-row">
							{planDetails.map((plan, index) => (
								<div className="mygrid-col-md-4">
									<div key={index} className={subscriptionPlanDetails?.planName === plan?.planName ? "plan_name selected" : "plan_name"} onClick={() => handleSelectedPlan(plan)}>
										{plan.planName}
									</div>
								</div>
							))}
						</div>
					</div>
					<div className="plans_names_wrappers">
						<div className="mygrid-row">
							{subscriptionPlanDetails?.subType &&
								Array.isArray(subscriptionPlanDetails?.subType) &&
								subscriptionPlanDetails?.subType?.map((subTypes, index) => (
									<div className="mygrid-col-xl-3 mygrid-col-md-4 mygrid-col-sm-6">
										<div key={index} className="plan_name_details" style={{ backgroundColor: subTypes?.color, position: "relative" }}>
											<h6 className="plan_name_details_price">{subTypes?.price}</h6>
											<p className="plan_name_details_price_per_month">({subTypes?.innerDetails?.permonth})</p>
											<p className="plan_name_details_price_per_subject">{subTypes?.innerDetails?.subject}</p>
											<p className="plan_name_details_price_per_teacher">{subTypes?.innerDetails?.teacher}</p>
											<p className="plan_name_details_price_per_students">{subTypes?.innerDetails?.students}</p>
											<p className="plan_name_details_price_per_validity">{subTypes?.innerDetails?.validity}</p>
											<div style={{ marginTop: "10px" }}>
												<CustomButton className="subscription_details_button" href="" text="Select Subjects" onClick={() => handleSelectSubjects(subscriptionPlanDetails, subTypes)} />
											</div>
											<img src={Layer1} alt="Layer1" className="layer1_image" />
										</div>
									</div>
								))}

						</div>
					</div>
				</div>

			)}
			{/* Render step components based on currentStep */}
			{currentStep !== 1 && responseSteps.map((step) => (currentStep === step.id ? step.stepComponent() : null))}
			<Footer />

		</SubscriptionDetailsContainer>
	);
}

export default SubscriptionDetails;
